
import { Waypoint } from 'react-waypoint';
import clsx from "clsx";

export const ProductGrid = (props) => {
    const { loadMoreContent, loadMoreTask, component, classes, productId } = props;

    return (
        <div className={clsx(classes.gridRowTop, classes.heightFull, productId, { [classes.disabled]: productId !== '' })} style={{ marginTop: "0" }}>
            <div className={clsx(classes.gridRow)}>
                {component}
                {
                    loadMoreContent && <Waypoint onEnter={({ previousPosition, currentPosition, event }) => {
                        setTimeout(function () {
                            loadMoreTask(previousPosition);
                        }, 500);
                    }}>
                        <div className={classes.textAlignCenter}>
                            <div className={classes.loadMoreCircle}></div>
                        </div>
                    </Waypoint>
                }
            </div>
        </div>
    )
}